import "../styles/styles.scss";
import "./global.js";
import "./main.js";
